// Client lib imports
const businessEvents = require('client/lib/business-events')
// Client V2 common imports
const routerActions = require('client-v2/common/state/router/actions')

// Action types
const APP_DOWNLOAD = 'LOHP_APP_DOWNLOAD'

// Action dispatchers

function appDownload(platform) {
  return async function (dispatch) {
    dispatch({ type: APP_DOWNLOAD })
    // Send a tracking call
    await businessEvents.trackSegment('app-download', { platform })
  }
}

function socialAuth(provider) {
  return async function (dispatch, getState) {
    // Wait for tracking before navigating away from page
    await businessEvents.trackSegment('social-auth', {
      authContext: 'lohp-v2',
      provider
    })
    const { pathname, search } = getState().router.location
    const r = encodeURIComponent(pathname + search)
    const href = `/auth/${provider}?r=${r}`
    dispatch(routerActions.navigate({ href }))
  }
}

module.exports = {
  // Action types
  APP_DOWNLOAD,
  // Action dispatchers
  appDownload,
  socialAuth
}
